import gql from 'graphql-tag';

export default gql`
  mutation signInUserMutation($login: String!, $password: String!) {
    signInUserMutation(login: $login, password: $password) {
      title
      message
    }
  }
`;
